import { ContractNegotiationVersionConcept } from '../models/Entities/Contracts/ContractNegotiationVersionConcept';
import { NewContractNegotiationVersionConcept } from '../models/Entities/Contracts/NewContractNegotiationVersionConcept';
import { IResult } from '../models/HttpResult';
import * as Functions from '../functions/common';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';

const GetRequestConfig = (token: string, method?: string, body?: unknown): RequestInit => ({
  method,
  body: body !== undefined ? JSON.stringify(body) : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  },
});

const HandleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    throw response;
  }

  const data = (await response.json()) as IResult<T>;
  return data.data;
};

const HandleError = async (error: any) => {
  const body = await error.text();
  throw Functions.HttpErrorHandler(body, error);
};

export const GetContractNegotiationVersionConcepts = async (contractNegotiationVersionId: string, token: string): Promise<ContractNegotiationVersionConcept[]> => {
  const requestUrl = BaseURL + 'negotiations/versions/' + contractNegotiationVersionId + '/concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationVersionConcept[]>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const GetContractNegotiationVersionConceptById = async (id: string, token: string): Promise<ContractNegotiationVersionConcept> => {
  const requestUrl = BaseURL + 'negotiations/version-concepts/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationVersionConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const CreateContractNegotiationVersionConcept = async (contractNegotiationVersionConcept: NewContractNegotiationVersionConcept, token: string): Promise<ContractNegotiationVersionConcept> => {
  const requestUrl = BaseURL + 'negotiations/version-concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'POST', contractNegotiationVersionConcept))
      .then((response) => HandleResponse<ContractNegotiationVersionConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const UpdateContractNegotiationVersionConcept = async (contractNegotiationVersionConcept: ContractNegotiationVersionConcept, token: string): Promise<ContractNegotiationVersionConcept> => {
  const requestUrl = BaseURL + 'negotiations/version-concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'PUT', contractNegotiationVersionConcept))
      .then((response) => HandleResponse<ContractNegotiationVersionConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const DeleteContractNegotiationVersionConcept = async (id: string, token: string): Promise<string> => {
  const requestUrl = BaseURL + 'negotiations/version-concepts/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'DELETE'))
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return id;
      })
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};